import React from 'react';
import {LazyImage} from "../../../Components";
import {detectEnglishLang} from "../../../Services";
import {Col, Row} from "antd";

function TriadBigLeftDesktop({item,left,left_bottom,left_top,LinkDispatcher}){



    return(

        <Row gutter={[16,4]} justify="center"  className="component-row">
            <Col xs={{ span: 18 }} sm={{ span: 18 }} md={{ span: 18 }} lg={{ span: 18}} >
                <div className="block-container">
                    {item.title?<div className="section-title"><span>{item.title}</span></div>:null}
                    {left?.image_desktop ? <div className={`block-pool ${item.has_shadow?"shadow-sec":""}`}
                                                style={{order: 1}}>

                        <div className="block-item-vertical">
                            <div className="wrapper"
                                 onClick={() => LinkDispatcher(left.link_to, left)}>
                                <img src={left.image_desktop} alt=""/>
                                <span className="block-title">{left.title}</span>
                            </div>
                        </div>

                        <div className="block-item-vertical">
                            <div className="wrapper"
                                 onClick={() => LinkDispatcher(left_top.link_to, left_top)}>
                                <img className="max-height" src={left_top.image_desktop} alt=""/>
                                <span className="block-title">{left_top.title}</span>
                            </div>
                            <div className="wrapper"
                                 onClick={() => LinkDispatcher(left_bottom.link_to, left_bottom)}>
                                <img className="max-height" src={left_bottom.image_desktop} alt=""/>
                                <span className="block-title">{left_bottom.title}</span>
                            </div>
                        </div>

                    </div> : null}
                </div>
            </Col>
        </Row>

    )
}

export default TriadBigLeftDesktop
